@if(mode==="edit" || mode==="add"){

<div class="ppl-mt20">
  @if(showSsnItinInfo) {
    <nz-alert style="margin-bottom: 16px;" nzType="info" nzMessage="Only one of SSN or ITIN can be added for a participant." nzShowIcon></nz-alert>
  }

  <form nz-form nz-row [formGroup]="identifierForm" class="ppl-p0">

    @if(isAttrAvailable('type')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="type">{{ getAttributes("type").label }}
          @if(getAttributes('type').mandatory === 'Y'){
          <span>*</span>
          }</nz-form-label>
        <nz-form-control class="ppl-form-control" nzLabelAlign="left" nzTooltipPlacement="topRight">
          <div [ngClass]="{'error': validationErrors['type'] }">
              <ppl-dropdown-select formControlName="type" [disabled]="mode === 'edit' && !isIdentifierTypeEditable"
              id="type" [(ngModel)]="selectedIdentifierValue" (ngModelChange)="onIdentifierTypeChange()"
              [options]="isIdentifierTypeEditable ? ssnItinOptions : identifiersList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
              [attr.aria-invalid]="validationErrors['type'] ? 'true' : 'false'"
              [attr.aria-describedby]="validationErrors['type'] ? 'type-error' : null">
              </ppl-dropdown-select>
          </div>
          @if (validationErrors['type']) {
          <span class="pl-1 error-message">{{validationErrors['type']}}</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>}

    @if(isAttrAvailable('value')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="value">{{getAttributes('value').label}}
          @if(getAttributes('value').mandatory === 'Y'){
          <span>*</span>
          }
        </nz-form-label>
        <nz-form-control class="ppl-form-control pl-2">
          @if(selectedIdentifierValue === 'SSN'){
          <nz-input-group [nzSuffix]="suffixTemplate" style="height: 32px; padding: 0px 11px;"
            [ngClass]="{'error': validationErrors['value'] || duplicateIdentifierError }">
            <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('value').tooltip}}" nzTooltipPlacement="topRight"
              [type]="ssnVisible ? 'text' : 'password'" formControlName="value" nzId="value"
              placeholder="{{getAttributes('value').placeholder}}" (input)="limitDigits($event)" />
          </nz-input-group>
          <ng-template #suffixTemplate>
            <!-- We use eslint-disable here because the button's content is supplied by the nz-icon directive -->
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button [attr.aria-label]="ssnVisible ? 'Hide SSN' : 'Show SSN'" class="ssn-visible" nz-icon
              [nzType]="ssnVisible ? 'eye' : 'eye-invisible'" (click)="ssnVisible = !ssnVisible"></button>
          </ng-template>
          }@else if(selectedIdentifierValue === 'ITIN'){
          <nz-input-group [nzSuffix]="itinSuffixTemplate" style="height: 32px; padding: 0px 11px;"
            [ngClass]="{'error': validationErrors['value'] || duplicateIdentifierError }">
            <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('value').tooltip}}" nzTooltipPlacement="topRight"
              [type]="itinVisible ? 'text' : 'password'" formControlName="value" nzId="value"
              placeholder="{{getAttributes('value').placeholder}}" (input)="limitItinDigits($event)" />
          </nz-input-group>
          <ng-template #itinSuffixTemplate>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button [attr.aria-label]="itinVisible ? 'Hide ITIN' : 'Show ITIN'" class="ssn-visible" nz-icon
              [nzType]="itinVisible ? 'eye' : 'eye-invisible'" (click)="toggleITIN()"></button>
          </ng-template>
          }@else if(selectedIdentifierValue === 'EINES'){
          <nz-input-group [nzSuffix]="einesSuffixTemplate" style="height: 32px; padding: 0px 11px;"
            [ngClass]="{'error': validationErrors['value'] || duplicateIdentifierError }">
            <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('value').tooltip}}" nzTooltipPlacement="topRight"
              [type]="einesVisible ? 'text' : 'password'" formControlName="value" nzId="value"
              placeholder="{{getAttributes('value').placeholder}}" (input)="limitDigits($event)" />
          </nz-input-group>
          <ng-template #einesSuffixTemplate>
            <!-- eslint-disable-next-line @angular-eslint/template/elements-content -->
            <button [attr.aria-label]="einesVisible ? 'Hide EINES' : 'Show EINES'" class="ssn-visible" nz-icon
              [nzType]="einesVisible ? 'eye' : 'eye-invisible'" (click)="einesVisible = !einesVisible"></button>
          </ng-template>
          }@else if(selectedIdentifierValue === 'EIN'){
          <!-- EIN is 9 digits like SSN/ITIN/EINES, so it shares limitDigits. Kept as a plain input
               (no password toggle) to match how EIN rendered before it had its own branch. -->
          <input nz-input nz-tooltip nzTooltipTitle="{{getAttributes('value').tooltip}}"
            nzTooltipPlacement="topRight" formControlName="value" nzId="value"
            placeholder="{{getAttributes('value').placeholder}}" (input)="limitDigits($event)"
            [ngClass]="{'error': validationErrors['value'] || duplicateIdentifierError }" />
          }@else{
          <input nz-input nz-tooltip [nzTooltipTitle]="getTooltipTitle()" nzTooltipPlacement="topRight"
            formControlName="value" id="value" placeholder="{{getAttributes('value').placeholder}}"
            [ngClass]="{'error': validationErrors['value'] || duplicateIdentifierError }" />
          }
          @if (validationErrors['value']) {
          <span class="pl-1 error-message">{{validationErrors['value']}}</span>
          }
          @if (ssnError) {
          <span class="pl-1 error-message">Please enter a valid SSN</span>
          }
          @if (cinError) {
          <span class="pl-1 error-message">Please enter a valid UCI ID in the format of seven numbers</span>
          }
          @if (einError) {
          <span class="pl-1 error-message">Please enter a valid EIN</span>
          }
          @if (einesError) {
          <span class="pl-1 error-message">Please enter valid 9 digit for Existing Employer Identification Number</span>
          }
          @if (tinError) {
          <span class="pl-1 error-message">Please enter a valid TIN</span>
          }
          @if (itinError) {
          <span class="pl-1 error-message">Please enter a valid ITIN (format: 9XX-XX-XXXX, where 4th-5th digits must be in the range of 50-65, 70-88, 90-92, or 94-99)</span>
          }
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }

    @if(isAttrAvailable('preferred')){
    <nz-form-item nz-col nzSpan="12" nzPaddingLeft="20" class="ppl-form-item nz-padding-left">
      <nz-row>
        <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="preferred"
          class="ppl-form-label">{{getAttributes('preferred').label}}</nz-form-label>
        <nz-form-control class="ppl-form-control">
          <nz-switch nzId="preferred" formControlName="preferred" pplNzAriaLabel nzAriaLabel="preferred"></nz-switch>
        </nz-form-control>
      </nz-row>
    </nz-form-item>
    }


  </form>

  @if(duplicateIdentifierError) {
    <nz-alert style="margin-bottom: 16px;" nzType="error" [nzMessage]="duplicateIdentifierError" nzShowIcon></nz-alert>
  }

</div>
<div class="custom-row">
  <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="cancelEdit()"></ppl-button>

  <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'" [iconPosition]="'left'"
    (click)="save()" *ngIf="canAddIdentifiers"></ppl-button>
</div>
}
@else if(mode === 'read'){
@if(leadStatus !== approvedStatus && requireIdentifiers && canAddIdentifiers) {
<div class="custom-row">
  <ppl-button label="Add" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'" (click)="add()"></ppl-button>

  <!-- <span nz-icon nzType="plus-circle" nzTheme="outline" (click)="add()"
        *authorize="[pageId, tabId, 'Identifiers', 'section', 'edit']"></span> -->
</div>
}

@if(deleteErrorMessage) {
  <nz-alert style="margin-bottom: 16px;" nzType="error" [nzMessage]="deleteErrorMessage" nzShowIcon></nz-alert>
}

@if(copyOfGridData.length > 0){
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="isSectionEditable || isSectionDeletable || canUnMask" [data]="copyOfGridData"
  [disableSelection]="true" [cols]="cols" (gridAction)="action($event)" [gridTitle]="false" [pagination]="false"
  [loadPage]="true" [actionButtons]="actionButtons">
</ppl-list-table>
}@else {
<nz-row>
  <p>No Data found</p>
</nz-row>
}

}@else{
<nz-row>
  <p>No Data found</p>
</nz-row>
}